import React from 'react'
import './ProfileCard.css';

const ProfileCard = () => {
    return (
        <div className="profilecard-container" id = "profile">
            <div className="info">
                <br/>
            <h3> About Dr Amola </h3>
            <p>Dr. Amola Kumar is an Orthopedics and Joint replacement Surgeon in Indore having more than 10 years of experience in the field of Orthopaedic surgery.
            <br/>
            <br/>
            <p>She completed his Six years of Orthopaedic training from prestigious All India Institute of Medical Sciences (AIIMS), New Delhi . Dr. Kumar specializes in Knee & Hip Replacement, Computer navigated TKR, Arthroscopic Knee surgery & Complex Fractures. He has experience of performing more than 2000 knee replacement till date </p>

            <h3>OPD Schedule</h3>
            <p> 10:00 am to 02:00 pm</p>
</p>
</div>
        </div>
    );
};

export default ProfileCard;